import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Historique.css";

type Message = { sender: "user" | "ai"; text: string };
type Conversation = { id: string; title: string; messages: Message[] };

const Historique: React.FC = () => {
    const [convs, setConvs] = useState<Conversation[]>([]);
    const [selectedId, setSelected] = useState<string | null>(null);
    const [isMobileView, setIsMobileView] = useState(false);
    const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);

    /* Dark‑mode auto */
    useEffect(() => {
        const darkModeMq = window.matchMedia("(prefers-color-scheme: dark)");
        const toggle = (e: MediaQueryListEvent) => document.body.classList.toggle("dark", e.matches);
        document.body.classList.toggle("dark", darkModeMq.matches);
        darkModeMq.addEventListener("change", toggle);
        return () => darkModeMq.removeEventListener("change", toggle);
    }, []);

    /* Responsive */
    useEffect(() => {
        const checkMobile = () => {
            setIsMobileView(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    /* Chargement des conversations */
    useEffect(() => {
        const raw = localStorage.getItem("vinomiam-conversations");
        if (!raw) return;
        const list: Conversation[] = JSON.parse(raw);
        setConvs(list);
        if (list.length) setSelected(list[list.length - 1].id);
    }, []);

    /* Suppression */
    const deleteConv = (id: string) => {
        setConfirmDeleteId(id); // Affiche le popup
    };

    const handleConfirmDelete = () => {
        if (!confirmDeleteId) return;
        const updated = convs.filter((c) => c.id !== confirmDeleteId);
        setConvs(updated);
        localStorage.setItem("vinomiam-conversations", JSON.stringify(updated));
        if (selectedId === confirmDeleteId) {
            setSelected(updated.length ? updated[updated.length - 1].id : null);
        }
        setConfirmDeleteId(null); // Cache le popup
    };


    const current = convs.find((c) => c.id === selectedId);

    return (
        <div className="history-wrapper">
            <div className="history-topbar">
                <h1>Historique</h1>
                <Link to="/" className="history-back">Retour au Chat</Link>
            </div>

            <div className="history-content">
                {(!isMobileView || (isMobileView && selectedId === null)) && (
                    <div className="history-sidebar">
                        {convs.length === 0 ? (
                            <div className="history-empty">Aucune conversation enregistrée.</div>
                        ) : (
                            convs.map((conv) => (
                                <div
                                    key={conv.id}
                                    className={`history-item ${selectedId === conv.id ? "active" : ""}`}
                                    onClick={() => setSelected(conv.id)}
                                >
                                    <div className="history-item-actions">
                                        <div className="history-title">
                                            {conv.title.length > 40 ? conv.title.slice(0, 40) + "…" : conv.title}
                                        </div>
                                        <button className="history-del" onClick={(e) => {
                                            e.stopPropagation();
                                            deleteConv(conv.id);
                                        }}>
                                            ✕
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}

                {(!isMobileView || (isMobileView && selectedId !== null)) && (
                    <div className="history-chatbox">
                        {isMobileView && (
                            <button className="history-back-mobile" onClick={() => setSelected(null)}>
                                ←
                            </button>
                        )}
                        <div className="history-messages">
                            {current ? (
                                current.messages.map((msg, idx) => (
                                    <div key={idx} className={`message ${msg.sender}`}>
                                        <strong>{msg.sender === "user" ? "👤 Vous" : "🍷 Vinomiam"} :</strong>
                                        <div dangerouslySetInnerHTML={{__html: msg.text}}/>
                                    </div>
                                ))
                            ) : (
                                <div className="history-placeholder">
                                    Sélectionnez une conversation pour voir son contenu.
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Popup de confirmation de suppression */}
            {confirmDeleteId && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Supprimer cette conversation ?</h3>
                        <p>Voulez-vous vraiment supprimer cette conversation ?</p>
                        <div className="popup-buttons">
                            <button onClick={handleConfirmDelete}>Oui</button>
                            <button onClick={() => setConfirmDeleteId(null)}>Non je veux garder ce souvenir impérissable au final</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default Historique;
